import React, { useState } from "react";
import Slider from "react-slick";
import {
  FooContent,
  FooRow,
  FooCol,
  FooColCarousel,
  FooDiv,
  FooLink,
} from "./FoobarMobilElements";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  selectLoginModal,
  selectRegisterModal,
  selectDepositModal,
  selectWithdrawModal,
  setShowUserRegisterModal,
  setShowUserLoginModal,
  setShowUserDepositModal,
  setShowUserWithdrawModal,
  selectShowUserMenuMobile,
  setShowUserMenuMobile,
  setUrlverify,
  setShowJumio,
} from "../../features/modals/modalsSlice";
import {
  selectBlockRetiro,
  selectDetectedCountry,
  selectId,
  selectLogged,
  selectNotVerifiedPeru,
  selectToken,
  setActivePage,
} from "../../features/user/userSlice";
import { ReactComponent as SportsIcon } from "../../assets/icons/sports.svg";
import { ReactComponent as HorseIcon } from "../../assets/icons/horses.svg";
import { ReactComponent as GamesIcon } from "../../assets/icons/games.svg";
import { ReactComponent as CasinoIcon } from "../../assets/icons/casino.svg";
import { ReactComponent as SlotsIcon } from "../../assets/icons/slots.svg";
import { ReactComponent as PokerIcon } from "../../assets/icons/asdepica.svg";
import { ReactComponent as PersonIcon } from "../../assets/icons/person.svg";
import { ReactComponent as CreditIcon } from "../../assets/icons/credit-card.svg";
import { ReactComponent as ChatIcon } from "../../assets/icons/chat.svg";
import Popover from "@mui/material/Popover";
import Fab from "@mui/material/Fab";
import Stack from "@mui/material/Stack";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import ChatIconAdd from "@mui/icons-material/Chat";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import { selectUser } from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import {
  selectLimites,
  setLimites,
} from "../../features/limitaciones/limitacionesSlice";
import { API_URL } from "../../const/api";
import axios from "axios";
import { comprobarTiempoInactivo } from "../../utils/tools";
import {
  errorNotification,
  infoNotification,
} from "../../utils/toastNotifications";
import SwalBlockRetiro from "../../components/SwalBlockRetiro";

const icons = [
  <SportsIcon />,
  <HorseIcon />,
  <ThreeDRotationIcon />,
  <GamesIcon />,
  <CasinoIcon />,
  <SlotsIcon />,
];

const FoobarMobil = ({}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleClickEvent = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseEvent = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const eventChat = () => {
    if (document.getElementById("retailcrm-consultant-app")) {
      handleCloseEvent();
      // document.querySelector(".window_mobile").style.display = "flex";
      document.querySelector(".consultant-icon").click();
      setTimeout(() => {
        document.querySelector(".messengers__item_consultant").click();
      }, 200);
    }
  };

  const [t, i18n] = useTranslation("global");
  const isLoged = useSelector(selectLogged);
  const registerModal = useSelector(selectRegisterModal);
  const loginModal = useSelector(selectLoginModal);
  const depositModal = useSelector(selectDepositModal);
  const showUserMenuMobile = useSelector(selectShowUserMenuMobile);
  const user = useSelector(selectUser);
  const limitaciones = useSelector(selectLimites);
  const notVerifiedPeru = useSelector(selectNotVerifiedPeru);
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const detectedCountry = useSelector(selectDetectedCountry);

  const blockRetiro = useSelector(selectBlockRetiro);

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(false);

  const getLimitaciones = async () => {
    let body = { id_uo, token };
    let tiempo_inactivo = "";
    try {
      const res = await axios.post(API_URL + "getLimitaciones", body);
      if (res.data.response !== null) {
        dispatch(setLimites(res.data.response));
        const fecha_config = res.data.response.fecha_config;
        tiempo_inactivo = res.data.response.tiempo_inactivo;

        //validamos si se cumplio el tiempo de inactividad
        if (
          tiempo_inactivo > 0 &&
          fecha_config &&
          comprobarTiempoInactivo(fecha_config)
        ) {
          // se cumplio el tiempo de inactividad y lo seteamos a 0
          body = {
            ...body,
            ...limitaciones,
            tiempo_inactivo: 0,
            fecha_config: null,
          };
          const res = await axios.post(API_URL + "setLimitaciones", body);
          if (res.data.response === "ok") {
            dispatch(
              setLimites({
                ...limitaciones,
                tiempo_inactivo: 0,
                fecha_config: null,
              })
            );
          }
        }
      }
    } catch (error) {
      //console.log(error);
    }

    return tiempo_inactivo;
  };

  const verificacionJumio = async () => {
    let body = {
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "verify", body);
    if (res.data.code === 200) {
      dispatch(setUrlverify(res.data.response_data.web.href));
      dispatch(setShowJumio(true));
    } else {
      if (res.data.message) {
        errorNotification(res.data.message, "top-center");
      } else {
        errorNotification(t("alert.errorNotificationRetiro-66"), "top-center");
      }
    }
  };

  const handleModals = (name, value) => {
    if (name === "register") dispatch(setShowUserRegisterModal(value));
    if (name === "login") dispatch(setShowUserLoginModal(value));

    if (name === "deposit" && limitaciones.tiempo_inactivo <= 0)
      dispatch(setShowUserDepositModal({ open: value, type: false }));
    if (name === "withdraw" && blockRetiro)
      dispatch(setShowUserDepositModal({ open: value, type: true }));

    if (
      name === "deposit" &&
      isLoged &&
      value === true &&
      limitaciones.tiempo_inactivo > 0
    ) {
      const tiempo = getLimitaciones();
      if (limitaciones.tiempo_inactivo > 0) {
        infoNotification(
          "Su cuenta se encuentra inactiva por indicaciones del usuario."
        );
      }
    }

    if (name === "withdraw" && isLoged && value === true && blockRetiro) {
      // infoNotification("Su cuenta no se encuentra verificada y no puede realizar esta accion.")
      SwalBlockRetiro(verificacionJumio);
    }
  };

  const hideModals = (link) => {
    dispatch(setShowUserMenuMobile(false));
    handleModals("register", false);
    handleModals("login", false);
    handleModals("deposit", false);
    handleModals("withdraw", false);
    dispatch(setActivePage(link));
  };
  const handleNavItems = (url) => {
    hideModals(url);
    if (
      (url === "header.link-2.url" || url === "header.link-7.url") &&
      !isLoged
    ) {
      dispatch(setShowUserLoginModal(true));
    }

    if (
      url === "header.link-4.url" &&
      window.location.pathname === t("header.link-4.url")
    )
      navigate(0);
    //if(url==='header.link-3.url'&&window.location.pathname ===  t("header.link-3.url")) navigate(0);

    const scrollfoobarmovil = document.getElementById("root");
    scrollfoobarmovil.scrollIntoView({ behavior: "smooth" });
  };

  const handleMenuUser = () => {
    !isLoged && (!loginModal ? handleModals("login", true) : handleClose());
    !isLoged && registerModal && handleModals("register", false);
    isLoged && depositModal && handleModals("deposit", false);
    isLoged && handleShowUserMenuMobile();
  };

  const handleClose = () => dispatch(setShowUserLoginModal(false));

  const handleShowUserMenuMobile = () => {
    dispatch(setShowUserMenuMobile(!showUserMenuMobile));
  };

  const settings = {
    centerMode: true,
    centerPadding: "0px",
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 6000,
  };
  const getUrlNav = (url) =>
    (url === "header.link-2.url" || url === "header.link-7.url") && !isLoged
      ? "#"
      : t(url);
  return (
    <FooContent>
      <FooRow>
        {!isLoged ? (
          <FooCol>
            <FooDiv onClick={handleMenuUser}>
              <PersonIcon />
              <p>Iniciar</p>
            </FooDiv>
          </FooCol>
        ) : (
          <FooCol>
            <FooLink
              clicked={clicked}
              onClick={() => {
                setClicked(false);
                handleModals("deposit", true);
              }}
            >
              <CreditIcon />
              <p>{t("header.btn-deposit")}</p>
            </FooLink>
          </FooCol>
        )}
        <FooColCarousel>
          <Slider {...settings}>
            {icons.map((item, key) => (
              <div
                key={key}
                onClick={() => handleNavItems(`header.link-${key + 1}.url`)}
              >
                <FooLink to={getUrlNav(`header.link-${key + 1}.url`)}>
                  {item}
                  <p>{t(`header.link-${key + 1}.title`)}</p>
                </FooLink>
              </div>
            ))}

            {detectedCountry !== "PE" && (
              <div onClick={() => handleNavItems(`header.link-7.url`)}>
                <FooLink to={getUrlNav(`header.link-7.url`)}>
                  {<PokerIcon />}
                  <p>{t(`header.link-7.title`)}</p>
                </FooLink>
              </div>
            )}
          </Slider>
        </FooColCarousel>
        <FooCol>
          <FooDiv
            aria-describedby={id}
            variant="contained"
            onClick={handleClickEvent}
          >
            <ChatIcon />
            <p>Soporte</p>
          </FooDiv>
          <Popover
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "transparent",
              },
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseEvent}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Stack spacing={1}>
              {/* <Fab size="small" color="success" aria-label="whatsApp" target="_blank" href="https://api.whatsapp.com/send/?phone=51912279063&type=phone_number&app_absent=0">
                                    <WhatsAppIcon />
                                </Fab> */}
              <Fab
                size="small"
                color="primary"
                aria-label="telegram"
                target="_blank"
                href="http://t.me/MasterBets365bot"
              >
                <TelegramIcon />
              </Fab>
              <Fab
                size="small"
                color="secondary"
                aria-label="add"
                onClick={eventChat}
              >
                <ChatIconAdd />
              </Fab>
            </Stack>
          </Popover>
        </FooCol>
      </FooRow>
    </FooContent>
  );
};
export default FoobarMobil;
